var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.42,
    height: 46.944,
    viewBox: "0 0 211.42 46.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_33",
    "data-name": "Groupe 33",
    transform: "translate(-1812.272 -174.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_27",
    "data-name": "Groupe 27",
    transform: "translate(1902.317 189.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    transform: "translate(0 20.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M2003.369,257.012a5.267,5.267,0,0,1-3.422,1.169c-2.923,0-5-1.67-5-4.981a4.959,4.959,0,0,1,5.12-5,4.56,4.56,0,0,1,3.172,1.224.9.9,0,0,1-1.211,1.336,2.938,2.938,0,0,0-1.962-.876,3.317,3.317,0,0,0-3.311,3.311,3.08,3.08,0,0,0,3.186,3.312,3.539,3.539,0,0,0,2.086-.626v-1.711h-2.086a.849.849,0,1,1,0-1.7h2.782a.953.953,0,0,1,.987.821v2.963A1.121,1.121,0,0,1,2003.369,257.012Z",
    transform: "translate(-1994.952 -248.106)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M2024.337,257.436a.925.925,0,0,1-1.85.028v-7.9a.831.831,0,0,1,.834-.849h3.7a3.091,3.091,0,0,1,1.308,5.914l1.85,2.254a.939.939,0,1,1-1.559,1.044l-2.1-3.006h-2.185Zm0-4.119h2.686c1.809,0,1.92-2.921,0-2.921h-2.686Z",
    transform: "translate(-2008.915 -248.364)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M2051.762,258.122a4.857,4.857,0,0,1-5.246-5.008,5.114,5.114,0,0,1,10.228,0A4.853,4.853,0,0,1,2051.762,258.122Zm-.153-8.307a3.3,3.3,0,1,0,3.311,3.3A3.185,3.185,0,0,0,2051.609,249.815Z",
    transform: "translate(-2021.099 -248.006)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M2082.908,249.582a.913.913,0,1,1,1.823,0v5.037c0,5.2-8.39,5.2-8.39,0v-5.037a.912.912,0,1,1,1.822,0v5.037c0,2.741,4.745,2.908,4.745,0Z",
    transform: "translate(-2036.223 -248.316)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M2102.969,249.419a.957.957,0,0,1,.947-.96h3.214a3.478,3.478,0,0,1,0,6.956h-2.323v1.837a.874.874,0,0,1-.89.96.94.94,0,0,1-.947-.96Zm1.837.793v3.465h2.323a1.733,1.733,0,0,0,0-3.465Z",
    transform: "translate(-2049.726 -248.236)",
    fill: "#333234"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_26",
    "data-name": "Groupe 26",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(24.027 1.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M2059.891,221.741H2054.9l-2.038-2.878h-8.548l1.2-2.74,5.4,0-5.616-7.924h5.078Z",
    transform: "translate(-2044.318 -208.203)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(34.962 1.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M2080.953,221.712h-4.892l-3.675-5.188.64-.082a5.541,5.541,0,0,0,2.891-1.163,2.1,2.1,0,0,0,.817-1.532c0-1.349-1.787-2.548-4.069-2.731-.205-.016-.417-.029-.632-.029s-3.159,0-3.29,0l-.206.005-.125-.168-1.911-2.667.743-.012,4.788,0c4.857,0,8.808,2.512,8.808,5.6a4.9,4.9,0,0,1-2.659,4.012Z",
    transform: "translate(-2066.504 -208.146)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10",
    transform: "translate(72.939 1.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M2148.22,211.274h-4.67v-3.1h4.67Z",
    transform: "translate(-2143.55 -208.173)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_13",
    "data-name": "Groupe 13",
    transform: "translate(52.194 1.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12",
    "data-name": "Groupe 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11",
    "data-name": "Groupe 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M2118.409,221.736h-4.524l-8.057-8.226v8.226h-4.365V208.173h4.4l8.184,8.4v-8.4h4.365Z",
    transform: "translate(-2101.463 -208.173)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_16",
    "data-name": "Groupe 16",
    transform: "translate(72.939 6.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15",
    "data-name": "Groupe 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_14",
    "data-name": "Groupe 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M2148.22,226.781h-4.67v-8.659h4.67Z",
    transform: "translate(-2143.55 -218.122)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(81.082 1.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18",
    "data-name": "Groupe 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17",
    "data-name": "Groupe 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M2177.023,221.736h-4.37v-8.226l-8.053,8.226h-4.53V208.173h4.363v8.405l8.188-8.405h4.4Z",
    transform: "translate(-2160.07 -208.173)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22",
    transform: "translate(101.223 0.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M2211.677,221.728a17.173,17.173,0,0,1-5.74-.875,7.872,7.872,0,0,1-3.742-2.547,5.927,5.927,0,0,1-1.265-3.647,5.717,5.717,0,0,1,1.415-3.8,8.807,8.807,0,0,1,4.078-2.508,16.333,16.333,0,0,1,5.029-.665,14.7,14.7,0,0,1,6.121,1.046,5.312,5.312,0,0,1,2.859,2.82l.182.469-4.668.545-.122-.245a2.875,2.875,0,0,0-1.47-1.3,6.888,6.888,0,0,0-2.9-.54,7.433,7.433,0,0,0-4.205,1.053,3.431,3.431,0,0,0-1.5,3.028,3.763,3.763,0,0,0,1.532,3.271,7.12,7.12,0,0,0,4.162,1.115,10.869,10.869,0,0,0,2.585-.321,11.737,11.737,0,0,0,2.077-.7V216.7H2211.3v-2.746h9.477v5.627l-.189.113a14.3,14.3,0,0,1-3.809,1.409A21.318,21.318,0,0,1,2211.677,221.728Z",
    transform: "translate(-2200.931 -207.683)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25",
    "data-name": "Groupe 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24",
    "data-name": "Groupe 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_23",
    "data-name": "Groupe 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M2012.278,220.541h-5.754l.018-8.4-5.341,8.4h-5.621l-.007-6.079,4.646-8.616-.011,9.022,5.44-7.87h5.51l-.015,7.56,4.131-7.56h4.592l-.641.853Z",
    transform: "translate(-1995.574 -205.846)",
    fill: "#333234"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_32",
    "data-name": "Groupe 32",
    transform: "translate(1812.272 174.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_31",
    "data-name": "Groupe 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M1838.747,178.707c-1.986-4.125-2.982-4.388-5.957-4.388h-20.518s24.288,42.659,25.723,44.644c1.908,2.643,3.869,1.969,4.447,1.175,1.066-1.474,5.244-8.931,7.562-13.095,1.519-2.719,1.628-3.837.093-7.25C1849.1,197.575,1840.733,182.833,1838.747,178.707Z",
    transform: "translate(-1812.272 -174.319)",
    fill: "#b70715"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_29",
    "data-name": "Groupe 29",
    transform: "translate(32.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M1899.809,174.315s-12.9-.008-17.212,0c-4.793.008-5.529,2.05-4.066,5.054,1.969,4.05,21.069,36.387,23.491,39.862,1.774,2.537,3.849,2.508,4.842.92s5.619-11.157,6.877-13.526a6.089,6.089,0,0,0-.028-6.022C1912.208,197.619,1899.809,174.315,1899.809,174.315Z",
    transform: "translate(-1877.857 -174.311)",
    fill: "#b70715"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30",
    transform: "translate(61.909 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M1941.283,174.319c-3.975,0-3.84,1.465-2.766,3.438,1.113,2.053,7.2,11.613,8.894,14.638,1.821,3.259,3.787,4.2,5,2.185,1.536-2.534,11.258-20.261,11.258-20.261Z",
    transform: "translate(-1937.87 -174.319)",
    fill: "#b70715"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLogo);
export default __webpack_public_path__ + "static/media/warningLogo.c9c7d4b743c91208a7f6b8899e6c817f.svg";
export { ForwardRef as ReactComponent };